type LessonNavigationProps = {
  hasPrev: boolean;
  hasNext: boolean;
  onPrev: () => void;
  onNext: () => void;
};

export function LessonNavigation({ hasPrev, hasNext, onPrev, onNext }: LessonNavigationProps) {
  if (!hasPrev && !hasNext) return null;

  return (
    <div className="flex items-center justify-between mt-8 pt-4 border-t border-gray-100">
      <div>
        {hasPrev && (
          <button
            onClick={onPrev}
            className="flex items-center gap-2 text-lg font-medium text-gray-500 hover:text-[#181b1a] transition-colors"
          >
            ← Anterior
          </button>
        )}
      </div>

      <div>
        {hasNext && (
          <button
            onClick={onNext}
            className="flex items-center gap-2 px-5 py-2.5 bg-orange text-white rounded-md text-lg font-medium hover:bg-orange/90 transition-colors"
          >
            Próximo →
          </button>
        )}
      </div>
    </div>
  );
}
